import React, {Component} from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import {Control, Errors} from "react-redux-form";

const propTypes = {
	name: PropTypes.string.isRequired,
	model: PropTypes.string.isRequired,
	file: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.any]),
	fetching: PropTypes.bool,
	disabled: PropTypes.bool,
	validators: PropTypes.object,
	message: PropTypes.object,
	comment: PropTypes.string, // comentario de la revisión
	status: PropTypes.string, // status de la revisión
	accept: PropTypes.string, // extensiones que acepta
	file_format: PropTypes.string // formato adjunto
}

const defaultProps = {
	disabled: false,
	comment: undefined,
	status: undefined
}

class BigFileUpload extends Component {
	render() {
		return (<div className={`control ${this.props.fetching ? 'is-loading' : ''}`}>
			{this.props.comment && <p className={`field-notification is-${this.props.status}`}>{this.props.comment}</p>}
			<div className={`file has-name is-boxed ${this.props.size ? 'is-'+this.props.size : ''} ${this.props.status && 'is-'+this.props.status}`}>
				<label className="file-label">
					<Control.file
						className="file-input"
						model={this.props.model}
						id="delegacy_majority_votes_constancy"
						accept={this.props.accept}
						disabled={this.props.disabled}
						errors={this.props.validators}
					/>
					{this.props.comment &&
					<span className="icon">
						<i className="fa fa-exclamation-circle"/>
					</span>}
					<span className="file-cta">
						<span className="file-icon">
							<i className="fa fa-upload"/>
						</span>
						<span className="file-label">{this.props.name}</span>
					</span>
				</label>
			</div>
			<Errors
				model={this.props.model}
				show="touched"
				wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
				messages={this.props.message}
			/>
			{this.props.file ?
			!_.isObject(this.props.file) ?
				<a href={this.props.file} className="help is-success" target="_blank">
					1 documento guardado <i className="fa fa-external-link" aria-hidden="true"/>
				</a> :
				<p className="help is-info">Un nuevo archivo cargado</p>
			: ''}

			{this.props.file_format ?
				<a href={this.props.file_format} className="help is-info" target="_blank">
					Descargar formato <i className="fa fa-external-link" aria-hidden="true"/>
				</a>:''}
		</div>)
	}
}

BigFileUpload.propTypes = propTypes;
BigFileUpload.defaultPros = defaultProps;

export default BigFileUpload;


// WEBPACK FOOTER //
// ./src/elements/widgets/big_file_upload.jsx